const NewLabel = () => {
    return (
        <div className="rounded-[5px] min-w-[48px] w-[48px] h-[20px] text-white bg-black text-[10px] sm:text-[12px] font-medium bg-gradient-green flex items-center justify-center">
            <div>New</div>
        </div>
    );
};

export default NewLabel;
